export const enableScriptForServiceWithConsent = () => {
  if (window.UC_UI && window.UC_UI.isInitialized()) {
    window.UC_UI.enableScriptsForServicesWithConsent();
  }
};
